module.exports = "/images/be.svg?b86c49a3e94b6639c18e9f0b50f18cde";